import React from "react";
import cx from "classnames";
import SanityBlockContent from "@sanity/block-content-to-react";
import { Serializer } from "src/utils/serializer";

export const BlockContent = ({ copy, layout, className }) => {
  if (!copy) {
    // console.error("Missing blocks");
    return null;
  }

  return (
    <div className={cx("block-content", layout, className)}>
      <SanityBlockContent blocks={copy} serializers={Serializer} />
    </div>
  );
};
